import { render } from "./ShortAbout.vue?vue&type=template&id=1f017432&scoped=true"
import script from "./ShortAbout.vue?vue&type=script&lang=js"
export * from "./ShortAbout.vue?vue&type=script&lang=js"

import "./ShortAbout.vue?vue&type=style&index=0&id=1f017432&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f017432"]])

export default __exports__